class MainMenu {
  constructor() {
    console.log('Main Menu has bem loaded')

    window.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        if (
          document.querySelector('#searchform').classList.contains('active')
        ) {
          document.querySelector('#searchform').classList.remove('active')
        }
      }
    })

    if (document.querySelector('header button.search')) {
      document
        .querySelector('header button.search')
        .addEventListener('click', (e) => {
          document.querySelector('#searchform').classList.add('active')
          document.querySelector('html').style.overflow = 'visible'
          e.stopPropagation()
        })

      document
        .querySelector('header button.search')
        .addEventListener('click', (e) => {
          document.querySelector('#searchform').classList.add('active')
          document.querySelector('html').style.overflow = 'visible'
          e.stopPropagation()
        })
    }

    document.addEventListener('click', () => {
      document.querySelector('#searchform').classList.remove('active')
    })

    document.querySelector('#searchform').addEventListener('click', (e) => {
      e.stopPropagation()
    })
  }
}

export default MainMenu
